<template>
    <div>
        <div v-if="formSection == `Drug`">
            <card title="Brand Record">
                <form>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.ndc" :disabled="disableFields" :required="true" label="NDC"
                                type="string" />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.name" :disabled="disableFields" label="Name" required />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="3">
                            <fg-input v-model.number="drug.awp" :disabled="disableFields" :no-wheel="true" label="AWP"
                                placeholder="$0.00" type="number">
                            </fg-input>
                        </b-col>
                        <b-col cols="3">
                            <fg-input v-model.number="drug.packageSize" :disabled="disableFields" :no-wheel="true"
                                label="Package Size" type="number">
                            </fg-input>
                        </b-col>
                        <b-col>
                            <fg-input v-model="drug.din"
                                :disabled="disableFields"
                                label="DIN"
                                type="string"/>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.unitOfMeasure" :disabled="disableFields" label="Unit of Measure"
                                required />
                        </b-col>
                        <b-col>
                            <fg-input v-model.number="drug.dispensingFee"
                                :disabled="disableFields"
                                label="Dispensing Fee"
                                type="number"
                                no-wheel/>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col cols="5">
                            <fg-input v-model.number="drug.minimumDispenseQuantity" :disabled="disableFields"
                                :no-wheel="true" label="Minimum Dispense Quantity" required type="number">
                            </fg-input>
                        </b-col>
                        <b-col cols="3">
                            <fg-input v-model.number="drug.deaClass" :disabled="disableFields" label="DEA Class"
                                type="number" />
                        </b-col>
                        <b-col cols="4">
                            <fg-input v-model.number="drug.auditChance" :disabled="disableFields" :no-wheel="true"
                                label="Audit Chance (%)" type="number" min="0" max="100"
                                placeholder="0-100">
                            </fg-input>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <EnumSelector v-model="drug.activeStatus" :disabled="disableFields" :enum-codes="statuses"
                                label="Status" required @input="disableSaveConfig"></EnumSelector>
                        </b-col>
                    </b-form-row>
                    <b-row>
                        <b-col>
                            <b-alert variant="danger" :show="disableSaveConfig">
                                <i class="fas fa-exclamation-triangle"></i>
                                Drug must have a cost associated with it to change its status
                                to Active.
                            </b-alert>
                        </b-col>
                    </b-row>
                    <hr>
                </form>
                <b-col cols="12">
                    <b-button :disabled="disableSaveConfig" variant="success"
                        @click="continueClicked">Continue</b-button>
                    <b-button @click="backToNonGSDDDashboard">Cancel</b-button>
                </b-col>
            </card>
        </div>

        <div v-if="formSection == `PatEd`">
            <card title="Patient Education Record">
                <form>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.patEd.description" :disabled="disableFields" label="Description" />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.patEd.contraindications" :disabled="disableFields"
                                label="Contraindications" />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.patEd.administration" :disabled="disableFields"
                                label="Administration" />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.patEd.missedDoseInstructions" :disabled="disableFields"
                                label="Missed Dose Instructions" />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.patEd.monitoring" :disabled="disableFields" label="Monitoring" />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.patEd.sideEffects" :disabled="disableFields" label="Side Effects" />
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col>
                            <fg-input v-model="drug.patEd.storage" :disabled="disableFields" label="Storage" />
                        </b-col>
                    </b-form-row>
                </form>
                <b-col cols="12">
                    <n-button type="success" @click="continueClicked">Continue</n-button>
                    <n-button @click="backToNonGSDDDashboard">Cancel</n-button>
                </b-col>
            </card>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import DisableAutocompleteMixin from '@/mixins/DisableAutocompleteMixin';
import { NonGSDDDrug } from '@/models/Drug/NonGSDDDrug';
import EnumSelector from '@/components/EnumSelector.vue';
import Checkbox from "@/components/Inputs/Checkbox.vue";
import { DrugStatus } from "@/models/Drug/Drug";
import { VendorDrugMap } from '@/models/VendorDrugMap';

@Component({
    name: "NonGSDDFormComponent",
    components: {
        EnumSelector,
        Checkbox
    }
})
export default class NonGSDDFormComponent extends Mixins(DisableAutocompleteMixin) {
    @Prop() private drug!: NonGSDDDrug;
    @Prop() private formSection!: string;
    protected statuses = DrugStatus.DrugStatusEnum;
    @Prop() protected vendors!: VendorDrugMap[];

    get disableFields(): boolean {
        return false
    }

    created() {
        //console.log("%c Created NonGSDDFormComponent", "color: green");
    }

    continueClicked() {
        if (this.drug.ndc == null || this.drug.name == null || this.drug.unitOfMeasure == null ||
            this.drug.minimumDispenseQuantity == null ||
            this.drug.ndc.trim() == "" || this.drug.name.trim() == "" || this.drug.unitOfMeasure.trim() == "" ||
            this.drug.minimumDispenseQuantity < 0.0001) {
            this.$bvModal.msgBoxOk(`Required Fields: NDC, Name, Unit of Measure, Minimum Dispense Quantity - can not be left empty`);
            return
        }
        if ((this.drug.deaClass as any) == "") this.drug.deaClass = undefined;

        (this.drug as any).billingUnit = this.drug.unitOfMeasure;
        this.$emit('continue');
    }

    backToNonGSDDDashboard() {
        this.$emit("close");
        return;
    }

    get disableSaveConfig() {
        if (this.drug.activeStatus == DrugStatus.DrugStatusEnum.Active ||
            this.drug.activeStatus == DrugStatus.DrugStatusEnum.ActiveAndPreferred) {
            return !this.drugHasCost;
        }
        return false;
    }

    get drugHasCost() {
        return this.vendors?.some(ven => ven.cost) ?? false;
    }
}
</script>

<style scoped></style>
